export enum ViewTypeEnum {
  Unknown_View = 'Unknown_View',
  MyRisk_MaplecroftRisk_View = 'MyRisk_MaplecroftRisk_View',
  RiskIndexView = 'RiskIndexView',
  CountryView = 'CountryView',
  MySiteView_MaplecroftSiteView = 'MySiteView_MaplecroftSiteView',
}
